import React, {useState, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {userCountrySelector} from '../../../../../store/selectors';
import * as S from './SelectCountry.styles';

const SelectCountry = ({options, onChange, classes}) => {
  const userCountry = useSelector(userCountrySelector);

  const [selectedIndex, setSelectedIndex] = useState(userCountry ? 1 : 0);
  const [toggle, setToggle] = useState(true);
  const [selectedCountry, setSelectedCountry] = useState(
    userCountry ? options[1].text : options[0].text,
  );

  const toggleSelectBox = () => {
    setToggle(toggle => !toggle);
    //onChange && onChange(!toggle);
  };
  const handleCountry = (item, idx) => {
    setSelectedCountry(item.text);
    setSelectedIndex(idx);
    setToggle(false);
    onChange && onChange(false, item);
  };

  return (
    <S.SelectContOuter className={classes}>
      {/* <S.SelectCont toggle={toggle} onClick={toggleSelectBox}>
        { !toggle && (
          <S.Flag>
            {userCountry ? (
              <img src="https://assets-gos3.goibibo.com/myp_UAE_Flag-1673868146.png" alt="UAE" />
            ) : (
              <img src="https://assets-gos3.goibibo.com/myp_GCC_IND_flag-1674563464.png" alt="IND" />
            )}
          </S.Flag>
        )}
        {toggle ? <span>Select Country</span> : <span>{selectedCountry}</span>} 
      </S.SelectCont> */}
      {toggle && (
        <div onClick={toggleSelectBox}>
          {options && options.length > 0 && (
            <S.SelectList>
              {options.map((item, index) => (
                <li key={item.id} onClick={() => handleCountry(item, index)}>
                  <S.Flag>
                    <img src={item.icon} alt="" />
                  </S.Flag>
                  <span>{item.text}</span>
                  {selectedIndex === index && <S.GreenIcon></S.GreenIcon>}
                </li>
              ))}
            </S.SelectList>
          )}
        </div>
      )}
    </S.SelectContOuter>
  );
};

export default SelectCountry;
